var render = function render(){var _vm=this,_c=_vm._self._c;return (
		(_vm.campaigns && _vm.campaigns.length) ||
			(_vm.location && _vm.location.type === 'dfp')
	)?_c('div',{staticClass:"sidearm-ad ad"},[(_vm.location && _vm.location.type)?_c(_vm.location.type,{tag:"component",attrs:{"name":_vm.name,"location":_vm.location,"campaigns":_vm.campaigns}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }